<template>
  <div class="mc-liveview--fo-sidebar-accordion-item">
    <div header-tag="header" role="tab">
      <div class="d-flex justify-content-between" v-b-toggle.accordion-2>
        <h5>Riwayat Penugasan</h5>
        <div>
          <i class="mc-fa icon-fill_arrow-ios-down"></i>
          <i class="mc-fa icon-fill_arrow-ios-up"></i>
        </div>
      </div>
    </div>
    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
      <div class="mc-liveview--fo-sidebar-history">
        <div
          v-for="(item, index) in processedHistory"
          :key="index"
          class="mc-liveview--fo-sidebar-history-item clearfix"
        >
          <div class="mc-liveview--fo-sidebar-history-item-line">
            <i class="mc-fa icon-outline_arrow-circle-right"></i>
          </div>
          <div class="mc-liveview--fo-sidebar-history-item-detail">
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton width="90%" />
                <b-skeleton width="70%" />
                <b-skeleton width="70%" />
                <b-skeleton width="60%" />
                <b-skeleton width="50%" />
                <b-skeleton width="60%" />
              </template>
              <p style="grid-area: history-date;">{{ formatIndexDate(item.created_on).date }}</p>
              <span class="text-muted" style="grid-area: history-time;">{{ formatIndexDate(item.created_on).time }}</span>
              <div style="grid-area: history-detail;">
                <p>{{ item.title }}</p>
                <div class="text-muted">
                  <span>{{ item.description }}</span>
                  <span
                    v-for="property in item.properties"
                    :key="`${property.key}-${property.value}`"
                  >
                    <div v-if="!property.key.toLowerCase().includes('delivery_order_uuid')">
                      <span v-if="property.key.toLowerCase().includes('tanggal')">
                        {{ property.key }}: {{ formatIndexDate(property.value).date }}
                        {{ formatIndexDate(property.value).time }}
                      </span>
                      <span v-else-if="property.value"> {{ property.key }}: {{ property.value }} </span>
                    </div>
                  </span>
                  <span v-if="item.clickable" class="text-primary" style="cursor: pointer" @click="handleShowDetailHistory(item)">
                    {{ item.clickableTitle }}
                  </span>
                </div>
              </div>
            </b-skeleton-wrapper>
          </div>
        </div>
        <div class="mc-liveview--fo-sidebar-history-item clearfix">
          <div class="mc-liveview--fo-sidebar-history-item-line">
            <i class="mc-fa icon-fill_radio-button-on"></i>
          </div>
        </div>
      </div>
    </b-collapse>
    <BulkDeliveryOrderHistoryDetail :data="selectedBulkDOHistory" />
  </div>
</template>

<script>
import { formatIndexDate } from '@/helpers/tzDate'
import BulkDeliveryOrderHistoryDetail from '@/router/views/fleet-task/components/BulkDeliveryOrderHistoryDetail'

export default {
  components: {
    BulkDeliveryOrderHistoryDetail,
  },
  props: {
    dataHistory: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedBulkDOHistory: {},
    }
  },
  computed: {
    isLoading() {
      return this.loading
    },
    processedHistory() {
      const deliveryOrderMap = {
        transferred_delivery_orders_added: {
          title: "Daftar DO yang Ditambahkan",
          label: "Ditambahkan pada: "
        },
        transferred_delivery_orders_moved: {
          title: "Daftar DO yang Dipindahkan",
          label: "Dipindahkan pada: "
        },
        assigned_delivery_orders: {
          title: "Daftar DO yang Ditugaskan",
          label: "Ditugaskan pada: "
        },
        canceled_delivery_orders: {
          title: "Daftar DO yang Dibatalkan",
          label: "Dibatalkan pada: "
        },
        rescheduled_orders: {
          title: "Daftar DO yang Dijadwalkan Ulang",
          label: "Dijadwalkan ulang pada: "
        }
      }
      const deliveryOrderKeys = ['transferred_delivery_orders', 'assigned_delivery_orders', 'canceled_delivery_orders', 'rescheduled_orders']

      return this.dataHistory.map((item) => {
        const isTransferTitleMoved = item.title?.toLowerCase().includes('dipindahkan')

        const idx = item.properties?.findIndex(prop => deliveryOrderKeys.includes(prop.key))

        if (idx === -1) return item

        const prop = item.properties[idx]

        if (prop.key === 'transferred_delivery_orders') {
          prop.key = isTransferTitleMoved ? 'transferred_delivery_orders_moved' : 'transferred_delivery_orders_added'
        }

        const config = deliveryOrderMap[prop.key]

        if (prop.value?.length > 3) {
          item = {
            ...item,
            index: item.created_on,
            clickable: true,
            clickableTitle: 'Lihat Detail DO',
            isBulk: true,
            modalTitle: config.title,
            labelCreatedOn: config.label,
            delivery_orders: item.properties[idx].value,
          }
        }

        return {
          ...item,
          properties: item.properties.filter((_, i) => i !== idx)
        }
      })
    },
  },

  methods: {
    formatIndexDate,
    handleShowDetailHistory(item) {
      if (item.isBulk) {
        this.selectedBulkDOHistory = item
        this.$nextTick(() => {
          this.$bvModal.show(`mc-modal-bulk-do-history-${item.index}`)
        })
      }
    },
  },
}
</script>
